import { CustomizerDataType } from "../../Types/ThemeCustomizerTypes";

export const navLinkList: CustomizerDataType[] = [
    {
        path: 'https://support.pixelstrap.com/',
        image: 'support.png',
        name: 'Support'
    },
    {
        path: 'https://docs.pixelstrap.net/react/lagos/document',
        image: 'setting.png',
        name: 'Document'
    },
    {
        path: 'https://landing.pixelstrap.net/react/lagos/template/',
        image: 'features.png',
        name: 'Check Features'
    },
    {
        path: 'https://www.pixelstrap.com/',
        image: 'document.png',
        name: 'Buy Now'
    }
]